import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { EMAIL, WHATSAPP_DISPLAY } from "@/constants/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "Nivaan Experiences respects your privacy. This placeholder policy outlines, in simple terms, how we handle the information you share with us. It will be reviewed and finalized with professional guidance.",
    points: [
      ["Information we collect", "When you submit a journey enquiry, we collect your name, contact details, travel preferences and any other information you choose to share."],
      ["How we use it", "We use your information solely to understand your requirements, prepare a personalized travel proposal and communicate with you about your journey."],
      ["Sharing", "We do not sell your personal information. Details are shared with travel providers only as needed to coordinate arrangements you have asked for."],
      ["Your choices", `You may ask us to update or delete your information at any time by writing to ${EMAIL}.`],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "These placeholder terms govern the use of the Nivaan Experiences website and our personalized travel planning service. They will be reviewed and finalized with professional guidance.",
    points: [
      ["Our service", "Nivaan Experiences provides personalized travel planning and journey coordination. Submitting an enquiry does not create a booking; a journey is confirmed only after you accept a written proposal and complete the agreed payment."],
      ["Proposals & pricing", "All quotations are personalized and based on destination, duration, dates, group size and inclusions. Advertised starting prices are indicative only."],
      ["Third-party services", "Flights, accommodation and activities are delivered by independent providers and remain subject to their own terms."],
      ["Contact", `Questions about these terms can be sent to ${EMAIL} or via WhatsApp at ${WHATSAPP_DISPLAY}.`],
    ],
  },
  cancellation: {
    title: "Cancellation Policy",
    intro: "This placeholder policy explains, in general terms, how cancellations are handled. Specific terms are always shared with your personalized proposal and will be reviewed and finalized with professional guidance.",
    points: [
      ["Before confirmation", "You may withdraw or modify an enquiry at any time before accepting a proposal, at no charge."],
      ["After confirmation", "Cancellation terms depend on the arrangements booked and the policies of airlines, hotels and other providers involved. Applicable terms are shared with you before you confirm."],
      ["Refunds", "Where refunds are due, they are processed after recoveries from the relevant providers, within a reasonable timeframe."],
      ["Contact", `To discuss a cancellation, write to ${EMAIL} or message us on WhatsApp at ${WHATSAPP_DISPLAY}.`],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <div data-testid={`legal-page-${type}`} className="min-h-screen bg-obsidian px-5 py-16 sm:px-8 lg:px-16">
      <div className="mx-auto max-w-3xl">
        <Link data-testid="legal-back-link" to="/" className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-zinc-400 transition-colors hover:text-gold">
          <ArrowLeft size={14} /> Back to Home
        </Link>
        <h1 className="mt-10 font-serif text-4xl font-light tracking-tight text-zinc-50 sm:text-5xl">{c.title}</h1>
        <p className="mt-6 text-sm font-light leading-relaxed text-zinc-400 sm:text-base">{c.intro}</p>
        <div className="mt-10 space-y-8">
          {c.points.map(([h, p]) => (
            <div key={h} className="border-l border-gold/30 pl-6">
              <h2 className="font-serif text-xl text-zinc-100">{h}</h2>
              <p className="mt-2 text-sm font-light leading-relaxed text-zinc-400">{p}</p>
            </div>
          ))}
        </div>
        <p className="mt-14 text-[11px] font-light text-zinc-600">
          © 2026 Nivaan Experiences — Every Journey. Personally Managed.
        </p>
      </div>
    </div>
  );
}
